import {
  fetcher,
  messageFromApiErrorBody,
  readJsonResponseBody,
} from '@commenda/utils';

export async function resyncRootFiCompany(
  rootFiCompanyId: number,
  fullResync = false
): Promise<{
  success: boolean;
  data?: { success: boolean };
  error?: unknown;
}> {
  try {
    const response = await fetcher(`rootfi/company/${rootFiCompanyId}/sync`, {
      method: 'POST',
      body: { fullResync },
    });

    if (!response.ok) {
      const errorBody = await readJsonResponseBody(response);
      return {
        success: false,
        error: messageFromApiErrorBody(errorBody, 'Failed to create sync'),
      };
    }

    const responseData = await readJsonResponseBody(response);
    return {
      success: true,
      data:
        typeof responseData === 'object' &&
        responseData &&
        'success' in responseData
          ? (responseData as { success: boolean })
          : undefined,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to create sync';
    return { success: false, error: errorMessage };
  }
}
